module.exports = "03b1c4d13a2bad676576015beb2dc1f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/select-level.png
// module id = 36
// module chunks = 0